"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelfranco-emilia": {
    "f6efb2c6": [{
      "hkey": "76128e8c",
      "slug": "gaggio",
      "name": "Gaggio",
      "primary": true,
      "skipSearch": false
    }],
    "gaggio-di-piano": [{
      "hkey": "76128e8c",
      "slug": "gaggio",
      "name": "Gaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "85699720": [{
      "hkey": "aaed79f9",
      "slug": "castelfranco-emilia",
      "name": "Castelfranco Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-degli-angeli": [{
      "hkey": "aaed79f9",
      "slug": "castelfranco-emilia",
      "name": "Castelfranco Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c968655": [{
      "hkey": "aaed79f9",
      "slug": "castelfranco-emilia",
      "name": "Castelfranco Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "casale-california": [{
      "hkey": "aaed79f9",
      "slug": "castelfranco-emilia",
      "name": "Castelfranco Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6a62b8c": [{
      "hkey": "93e35d67",
      "slug": "panzano-pioppa",
      "name": "Panzano-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "panzano": [{
      "hkey": "93e35d67",
      "slug": "panzano-pioppa",
      "name": "Panzano-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e74ed77d": [{
      "hkey": "93e35d67",
      "slug": "panzano-pioppa",
      "name": "Panzano-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "pioppa": [{
      "hkey": "93e35d67",
      "slug": "panzano-pioppa",
      "name": "Panzano-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castelfranco-emilia"
    }]
  }
};
exports["default"] = _default;